import React, { Fragment } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const Slider = ({ values }) => {
    const CarouselSettings = {
        showStatus: false,
        showThumbs: false,
        infiniteLoop: true,
        interval: 5000,
        autoPlay: true,
        showIndicators: values.length > 1,
        swipeable: true
    };

    return (
        <Carousel {...CarouselSettings}>
            {values.map((value, index) => (
                <Fragment>
                    {
                        value.url !== "" ? <a className="slider__link" href={value.url} key={`figure${index}`}>
                            <img className="slider__image" src={value.image} />
                            <h2 className="slider__text">{value.text}</h2>
                        </a>
                            : <div className="slider__link" href={value.url} key={`figure${index}`}>
                                <img className="slider__image" src={value.image} />
                                <h2 className="slider__text">{value.text}</h2>
                            </div>}
                </Fragment>
            )
            )}
        </Carousel>
    );
};

export default Slider;